
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_137oz_3",
  "root": "awsui_root_p8a6i_137oz_19",
  "header": "awsui_header_p8a6i_137oz_34",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_137oz_47",
  "header-refresh": "awsui_header-refresh_p8a6i_137oz_47",
  "list": "awsui_list_p8a6i_137oz_53",
  "list-grid-1": "awsui_list-grid-1_p8a6i_137oz_61",
  "card": "awsui_card_p8a6i_137oz_3",
  "list-grid-2": "awsui_list-grid-2_p8a6i_137oz_64",
  "list-grid-3": "awsui_list-grid-3_p8a6i_137oz_67",
  "list-grid-4": "awsui_list-grid-4_p8a6i_137oz_70",
  "list-grid-5": "awsui_list-grid-5_p8a6i_137oz_73",
  "list-grid-6": "awsui_list-grid-6_p8a6i_137oz_76",
  "list-grid-7": "awsui_list-grid-7_p8a6i_137oz_79",
  "list-grid-8": "awsui_list-grid-8_p8a6i_137oz_82",
  "list-grid-9": "awsui_list-grid-9_p8a6i_137oz_85",
  "list-grid-10": "awsui_list-grid-10_p8a6i_137oz_88",
  "list-grid-11": "awsui_list-grid-11_p8a6i_137oz_91",
  "list-grid-12": "awsui_list-grid-12_p8a6i_137oz_94",
  "list-grid-13": "awsui_list-grid-13_p8a6i_137oz_97",
  "list-grid-14": "awsui_list-grid-14_p8a6i_137oz_100",
  "list-grid-15": "awsui_list-grid-15_p8a6i_137oz_103",
  "list-grid-16": "awsui_list-grid-16_p8a6i_137oz_106",
  "list-grid-17": "awsui_list-grid-17_p8a6i_137oz_109",
  "list-grid-18": "awsui_list-grid-18_p8a6i_137oz_112",
  "list-grid-19": "awsui_list-grid-19_p8a6i_137oz_115",
  "list-grid-20": "awsui_list-grid-20_p8a6i_137oz_118",
  "selection-control": "awsui_selection-control_p8a6i_137oz_122",
  "loading": "awsui_loading_p8a6i_137oz_131",
  "empty": "awsui_empty_p8a6i_137oz_132",
  "has-header": "awsui_has-header_p8a6i_137oz_139",
  "card-header": "awsui_card-header_p8a6i_137oz_176",
  "card-header-inner": "awsui_card-header-inner_p8a6i_137oz_182",
  "card-selectable": "awsui_card-selectable_p8a6i_137oz_186",
  "card-selected": "awsui_card-selected_p8a6i_137oz_189",
  "section": "awsui_section_p8a6i_137oz_198",
  "section-header": "awsui_section-header_p8a6i_137oz_204",
  "section-content": "awsui_section-content_p8a6i_137oz_210"
};
  